import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import useLiveTheArt from "../hooks/useLiveTheArt";
import { getLivetheart } from "../services/livetheArt.service";

function LivetheArt() {
  const [banners, setBanners] = useState([]);
  const { leftImage, rightImage } = useLiveTheArt(banners);
  const sectionRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  // Fetch API Data
  useEffect(() => {
    const fetchData = async () => {
      const data = await getLivetheart();
      setBanners(data);
    };
    fetchData();
  }, []);

  //  Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Progress (only for zoom)
  useEffect(() => {
    if (!isDesktop) return;

    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const scrollStart = windowHeight;
      const scrollEnd = -rect.height;
      const value =
        (scrollStart - rect.top) / (scrollStart - scrollEnd);
      const clamped = Math.max(0, Math.min(value, 1));
      setProgress(clamped);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDesktop]);

  // Smooth zoom (no aggressive effect)
  const easeProgress = progress;

  return (
    <section
      ref={sectionRef}
      className="section_collection position-relative d-flex justify-content-center align-items-center"
      style={{
        overflow: "hidden",
        minHeight: "600px",
      }}
    >
      {/* CENTER CONTENT */}
      <div className="collection-content text-center">
        <h2 className="tagline">
          <em>Live the Art</em>
          <br />
          of&nbsp;Home
        </h2>

        <p className="lead-copy">
          Every room tells a story, and the pieces you bring into it become part
          of the narrative. At Obsessions, we believe home is more than just a
          place; it’s a feeling.
        </p>

        <Link to="/collections">
          <button className="hero-button">
            CHECK OUR COLLECTIONS
          </button>
        </Link>
      </div>

      {/* LEFT IMAGE */}
      {leftImage && (
        <div
          className="collection-img-wrap img-left"
          style={{
            transform: isDesktop
              ? `scale(${0.9 + easeProgress * 0.5})`
              : "none",
            transition: "transform 0.2s linear",
          }}
        >
          <img src={leftImage} alt="Left Art" />
        </div>
      )}

      {/* RIGHT IMAGE */}
      {rightImage && (
        <div
          className="collection-img-wrap img-right"
          style={{
            transform: isDesktop
              ? `scale(${0.7 + easeProgress * 0.5})`
              : "none",
            transition: "transform 0.2s linear",
          }}
          >
          <img src={rightImage} alt="Right Art" />
        </div>
      )}
    </section>
  );
}
export default LivetheArt;